import Venues from './Venues'

export default Venues
